import React, {useState, useEffect} from 'react';
import Helmet from 'react-helmet';
import cx from 'classnames';
import {SkipNavLink, SkipNavContent} from '@reach/skip-nav';
import {Header} from 'src/components/header';
import {Footer} from 'src/components/footer';
import {CartDrawer} from 'src/components/cart/drawer';
import {SearchDrawer} from 'src/components/search-drawer';
import {SignupDrawer} from 'src/components/signup-drawer';
import {useStoreContext} from 'src/context/storeContext';

import 'src/styles/main.css';

const Layout = ({children, location}) => {
	const {noticeBarHeight} = useStoreContext();

	const [isClient, setClient] = useState(false);
	const [enableFocusOutlines, setEnableFocusOutlines] = useState(false);

	useEffect(() => {
		setClient(true);
		window && window.addEventListener('keydown', handleKeydown);
		return () =>
			window && window.removeEventListener('keydown', handleKeydown);
	}, []);

	const key = isClient ? 'client' : 'server';

	const handleKeydown = e => {
		// Detect a keyboard user from a tab key press
		const isTabEvent = e.keyCode === 9;

		if (isTabEvent) {
			setEnableFocusOutlines(true);
		}
	};

	return (
		<>
			<Helmet
				title="Erica Weiner"
				htmlAttributes={{
					class: cx(enableFocusOutlines ? '' : 'no-outline-on-focus'),
				}}>
				<style>
					{`:root {
            --notice-bar-height: ${noticeBarHeight || 0}px;
          }`}
				</style>
			</Helmet>
			<SkipNavLink />
			<div>
				<Header />
				<CartDrawer />
				<SearchDrawer />
				<SignupDrawer location={location} />
				<div className="page-container" key={key}>
					<SkipNavContent />
					<main className="page-content">{children}</main>
					<Footer location={location} />
				</div>
			</div>
		</>
	);
};

export default Layout;
